import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AdminLoginPage from './components/auth/AdminLoginPage';
import KioskApp from './components/kiosk/KioskApp';
import AdminDashboard from './components/admin/AdminDashboard';
import WatchPage from './components/watch/WatchPage';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Kiosk — root URL, no login required, always Court 1 */}
          <Route path="/" element={<KioskApp />} />

          {/* Watch page — where the emailed link / QR code lands. Public,
              no login required. Was previously unrouted here, so it fell
              through to the catch-all below and bounced back to "/". */}
          <Route path="/v/:code" element={<WatchPage />} />

          {/* Admin login — separate URL */}
          <Route path="/admin/login" element={<AdminLoginPage />} />

          {/* Admin dashboard — protected */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute requiredRole="admin">
                <AdminDashboard />
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
